















import { defineComponent } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import QuestionnaireForm from '@/components/organisms/questionnaire/QuestionnaireForm.vue'
import { useActions, useGetters } from 'vuex-composition-helpers'
import { UserGetters } from '@/store/user/getters'
import { UpdateQuestionnaireDto } from '../../../api/@types'
import { QuestionnaireActions } from '@/store/questionnaire/actions'
import { QuestionnaireGetters } from '@/store/questionnaire/getters'

export default defineComponent({
  name: 'QuestionnaireEdit',
  components: { Layout, QuestionnaireForm },
  setup(props, context) {
    const { user } = useGetters<UserGetters>('user', ['user'])
    const { updateQuestionnaire } = useActions<QuestionnaireActions>(
      'questionnaire',
      ['updateQuestionnaire'],
    )

    const { questionnaire } = useGetters<QuestionnaireGetters>(
      'questionnaire',
      ['questionnaire'],
    )

    const isAutomatic = context.root.$route.path.includes('automatic')

    const save = async (body: UpdateQuestionnaireDto) => {
      const id = parseInt(context.root.$route.params.id)
      await updateQuestionnaire({ id, body })
      const path = context.root.$route.path.replace('edit', 'detail')
      context.root.$router.push(path)
    }

    const cancel = () => {
      const path = context.root.$route.path.replace('edit', 'detail')
      context.root.$router.push(path)
    }
    return { user, questionnaire, save, isAutomatic, cancel }
  },
})
